// extracted by mini-css-extract-plugin
export default {"container":"DG-z","disabled":"EG-z","bgBlack":"FG-z","content":"GG-z","countdown":"HG-z","topCaption":"IG-z","topHeading":"JG-z","heading":"KG-z","copy":"LG-z"};